import { BASE, safeFetch } from "./client";
import type { Attachment } from "../types";

/** URL of the stored original document for a synced attachment. */
export function attachmentFileUrl(attachmentId: string): string {
  return `${BASE}/attachments/${encodeURIComponent(attachmentId)}/file`;
}

/** Uploads a real document file as a new attachment on an email. */
export async function uploadAttachment(
  emailId: string,
  file: File,
  opts: { docType?: string; version?: number } = {},
): Promise<Attachment | null> {
  const form = new FormData();
  form.append("file", file);
  if (opts.docType) form.append("doc_type", opts.docType);
  if (opts.version) form.append("version", String(opts.version));
  try {
    const r = await fetch(`${BASE}/emails/${encodeURIComponent(emailId)}/attachments`, {
      method: "POST",
      body: form,
    });
    if (!r.ok) return null;
    const j = (await r.json()) as { attachment?: Attachment };
    return j.attachment ?? null;
  } catch {
    return null;
  }
}

export async function deleteAttachment(attachmentId: string): Promise<boolean> {
  const r = await safeFetch<{ ok: boolean }>(`/attachments/${encodeURIComponent(attachmentId)}`, {
    method: "DELETE",
  });
  return !!r?.ok;
}
